var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBraavosIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "-3 0 40 41"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.9069 3.39123C22.9666 3.49524 22.8876 3.62382 22.7701 3.62382C20.3907 3.62382 18.4564 5.55997 18.411 7.96588C17.5963 7.80954 16.7521 7.79779 15.9181 7.9422C15.8605 5.54728 13.9311 3.62382 11.5595 3.62382C11.4419 3.62382 11.3628 3.49514 11.4226 3.39105C12.5744 1.38621 14.7147 0.0390625 17.1647 0.0390625C19.6148 0.0390625 21.7551 1.38629 22.9069 3.39123Z",
  fill: "url(#paint0_linear_2354_12634)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.954 18.2713C30.7634 18.5232 31.526 17.7921 31.2206 16.9816C28.9507 10.9587 22.2323 8.49122 17.1321 8.49122C12.022 8.49122 5.15394 11.0385 3.03186 17.0192C2.74616 17.8244 3.50679 18.5314 4.3041 18.2803L16.5265 14.431C16.8793 14.3199 17.2563 14.3193 17.6095 14.4292L29.954 18.2713Z",
  fill: "url(#paint1_linear_2354_12634)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.91256 19.4308L16.5368 15.184C16.8875 15.0747 17.2618 15.0744 17.6127 15.1831L31.3225 19.4329C32.4674 19.7878 33.2508 20.8716 33.2508 22.1006V34.9048C33.1977 38.0302 30.4659 40.5353 27.426 40.5353H22.3768C21.8777 40.5353 21.4735 40.1204 21.4735 39.6074V35.1181C21.4735 33.3504 22.4914 31.7505 24.0665 31.0423C26.178 30.0931 28.6758 28.8091 29.1456 26.2325C29.2973 25.4009 28.7697 24.5987 27.9626 24.4339C25.9218 24.017 23.6594 24.178 21.7462 25.0575C19.5743 26.0559 19.0061 27.7167 18.7958 29.9472L18.5409 32.35C18.463 33.0845 17.7931 33.6471 17.0746 33.6471C16.3314 33.6471 15.7741 33.0653 15.6935 32.3055L15.4433 29.9472C15.2631 28.0367 14.9365 26.1808 13.0148 25.2974C10.8228 24.2897 8.61992 23.9551 6.27649 24.4339C5.46942 24.5987 4.9418 25.4009 5.09344 26.2325C5.56735 28.8315 8.04562 30.0861 10.1726 31.0423C11.7477 31.7505 12.7656 33.3504 12.7656 35.1181V39.6066C12.7656 40.1196 12.3616 40.5353 11.8625 40.5353H6.81311C3.77316 40.5353 1.04137 38.0302 0.988281 34.9048V22.0973C0.988281 20.8699 1.76973 19.787 2.91256 19.4308Z",
  fill: "url(#paint2_linear_2354_12634)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2354_12634",
  x1: 16.8032,
  y1: -2.14774,
  x2: 31.6598,
  y2: 40.4802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5B75E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2354_12634",
  x1: 16.8032,
  y1: -2.14774,
  x2: 31.6598,
  y2: 40.4802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5B75E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_2354_12634",
  x1: 16.8032,
  y1: -2.14774,
  x2: 31.6598,
  y2: 40.4802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5B75E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9600"
})))));
export default SvgBraavosIcon;